module.exports = __webpack_public_path__ + "assets/9b883437d39cdec3425f5c628bdedb77.png";